import React from 'react';
import { Button } from '@agconnections/grow-ui';
import PlusIcon from 'assets/plus.svg?react';
import { isSelectKey } from 'components/TagManager/helpers/keyboardUtils';

interface CreateNewButtonProps {
  onCreateNew: () => void;
  text?: string;
}

const CreateNewButton: React.FC<CreateNewButtonProps> = ({
  onCreateNew,
  text = 'Create New'
}) => {
  return (
    <div className="flex justify-center border-t border-solid border-neutral-100">
      <div className="mx-4 my-2 w-full h-full">
        <Button
          onClick={onCreateNew}
          onKeyDown={(e: React.KeyboardEvent) => {
            e.preventDefault();
            if (isSelectKey(e.key)) {
              onCreateNew();
            }
          }}
          style={{ width: '100%' }}
          type="outline"
          dataTestId="item-drop-bottom-button"
          icon={<PlusIcon />}
        >
          {text}
        </Button>
      </div>
    </div>
  );
};

export default CreateNewButton;
